import { useState, useEffect } from 'react';
import { Header } from '../../common/Header/Header.jsx';
import { useParams } from 'react-router-dom';
import { papService } from "../../../services/papService.js"
import { dbHistoryService } from '../../../services/dbHistoryService.js';
import { notify } from '../../../assets/helpers/toast.js';
import { PAPClientInfoCard } from './PAPClientInfoCard.jsx';
import { PAPAfiliationCard } from "./PAPAfiliationCard.jsx"
import { salesMembershipStatus } from '../../../assets/helpers/options.js';
import { SalesButtons, CancelOrderButton } from '../../common/Buttons/Buttons.jsx';
import { salesRoles } from '../../../assets/helpers/roles.js';
import authService from '../../../services/authService.js';
import {
  EditHistoryModal,
  AnnulPAPModal,
} from '../../common/Modals/Modals.jsx';
import {
  rcvEnum,
  membershipCodes,
  papStatus,
  membershipAnnulationOptions,
  isNewPlanRulesActive,
} from '../../../assets/helpers/options.js';
import { CraneCounter } from '../../common/Buttons/CraneCounter.jsx';
import moment from 'moment';
import { capitalize } from '../../../assets/helpers/funciones.js';

const itemsPerpage = [10, 25, 50, 100, 500];

export const PAPOrder = () => {
  const { membershipId } = useParams();
  const [membership, setMembership] = useState('');
  const [editHistory, setEditHistory] = useState({
    isOpen: false,
    limit: itemsPerpage[0],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: true,
  });
  const [showAnnulModal, setShowAnnulModal] = useState({
    show: false,
    papId: '',
    cancelOptions: membershipAnnulationOptions,
  });

  const getSalesMembershipById = (membershipId) => {
    papService
      .getPAPById(membershipId)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setMembership(response?.data?.papMembership);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const handlePageChange = (event, value) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * editHistory?.limit,
      };
    });
  };

  const handleEditModal = () => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        isOpen: !editHistory?.isOpen,
      };
    });
  };

  const handleDateFrom = (e) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        dateFrom: e,
      };
    });
  };
  const handleDateTo = (e) => {
    setEditHistory((prevState) => {
      return {
        ...prevState,
        dateTo: e,
      };
    });
  };

  const getHistory = (membershipId) => {
    let params = {
      page: editHistory?.page,
      limit: editHistory?.limit,
      from: moment(editHistory?.dateFrom).format('YYYY-MM-DD'),
      to: moment(editHistory?.dateTo).format('YYYY-MM-DD'),
    };

    dbHistoryService
      .getMembershipHistory(membershipId, params)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setEditHistory((prevState) => {
            return {
              ...prevState,
              data: response?.data?.history,
              count: response?.data?.total,
            };
          });
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const reloadMembership = () => {
    getSalesMembershipById(membershipId);
  };

  const handleAnnulModal = () => {
    setShowAnnulModal((prevState) => {
      return {
        ...prevState,
        show: !showAnnulModal?.show,
        papId: membership?._id,
      };
    });
  };

  const membershipName = (membership) => {
    // let status = renameMembershipStatus(membership?.status);
    let status = membership?.status;
    let id = 'Nro. ' + membership?.code + ' ';

    if (status !== 'INCOMPLETO' || membership.mainMembership) {
      status = ' (' + capitalize(status) + ') ';
    } else {
      status = ' Por Renovacion';
      id = '';
    }
    return <span>{id + status}</span>;
  };

  useEffect(() => {
    getSalesMembershipById(membershipId);
  }, []);

  useEffect(() => {
    getHistory(membershipId);
  }, [
    editHistory?.page,
    editHistory?.limit,
    editHistory?.dateFrom,
    editHistory?.dateTo,
  ]);

  return (
    <>
      <CraneCounter handleModal={handleEditModal} />
      <EditHistoryModal
        handleDateTo={handleDateTo}
        handleDateFrom={handleDateFrom}
        modal={editHistory}
        handlePageChange={handlePageChange}
        handleModal={handleEditModal}
      />
      <AnnulPAPModal
        showAnnulModal={showAnnulModal}
        handleClose={handleAnnulModal}
        refresh={reloadMembership}
      />
      <Header />
      {membership && (
        <div className="service-with-container container">
          <h1 className="title-component">
            Orden {membershipName(membership)}
          </h1>
          <div className="breadcrumb-container"></div>
          <div className="filter-button-container"></div>
          <br />
          <div className="row">
            <div className="col-12 col-lg-9">
              <PAPClientInfoCard
                label={'INFORMACIÓN DEL CLIENTE'}
                membership={membership}
                reloadMembership={reloadMembership}
              />
              <PAPAfiliationCard
                label={'DATOS DE AFILIACIÓN'}
                membership={membership}
                reloadMembership={reloadMembership}
              />
              {[salesRoles?.SALES_ADMIN, salesRoles?.SALES_SUPERVISOR].includes(
                authService.getUserType()
              ) &&
                membership?.status !== papStatus?.ANNULLED && (
                  <CancelOrderButton
                    label={'Anular Membresía PAP'}
                    action={handleAnnulModal}
                  />
                )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const UpgradeButton = (props) => {
  const { membership, upgradeOrder } = props;

  const isWithinFiveDays = (creationDate) => {
    const currentDate = moment();
    const createdDate = moment(creationDate);
    const differenceInDays = currentDate.diff(createdDate, 'days');

    return differenceInDays <= 5;
  };

  if (
    ['GOLD', 'GOLDM'].includes(membership?.membershipPlan) &&
    (isNewPlanRulesActive() || membership?.km === 300) &&
    membership.hasExtendedTow === true
  ) {
    return null;
  }

  if (
    [
      salesRoles?.SALES_ADMIN,
      salesRoles?.SALES_SUPERVISOR,
      salesRoles?.SALES_HUNTER,
      salesRoles?.SALES_FARMER,
      salesRoles?.SALES_COUNTER,
      salesRoles?.SALES_FARMER,
      salesRoles?.SALES_KEY_ACCOUNTS,
    ].includes(authService.getUserType()) &&
    ([
      salesMembershipStatus.ACTIVO,
      salesMembershipStatus.POR_RENOVACION,
    ].includes(membership?.membershipStatus) ||
      isWithinFiveDays(membership?.createdAt)) &&
    ['CLASSIC', 'PLUS', 'GOLD', 'GOLDM', 'CLASSICM', "PLUSM", 'MOTORIDER', 'BARATICO'].includes(
      membership?.membershipPlan
    )
  )
    return (
      <SalesButtons
        label={'Upgrade Plan'}
        active={true}
        action={() => upgradeOrder(membership?._id)}
      />
    );
  else return null;
};

export const RCVButton = (props) => {
  const { membership, action } = props;

  if (
    membership?.rcv === rcvEnum?.NA &&
    ![membershipCodes?.F2, membershipCodes?.PLUSF4]?.includes(
      membership?.membershipPlan
    )
  ) {
    return (
      <SalesButtons
        label={'Solicitud RCV'}
        active={true}
        action={() => action(membership)}
      />
    );
  } else return null;
};

export const MedCertButton = (props) => {
  const { membership, action, label } = props;
  return (
    <SalesButtons
      label={label}
      active={true}
      action={() => action(membership)}
    />
  );
};
